import Icons from '../../../../common/widgets/Icons';

export default function IconsShowcase() {
  return (
    <div style={{ display: 'flex', flexWrap: 'wrap' }}>
      <div style={{ width: '20%', padding: '0.5rem' }}>
        <div
          style={{
            height: '100%',
            padding: '1rem',
            border: '1px solid #c5c9ce',
            borderRadius: 5,
          }}
        >
          <div style={{ display: 'flex', justifyContent: 'center' }}>
            <Icons.Add />
          </div>
          <span
            style={{
              display: 'block',
              paddingTop: '1rem',
              textAlign: 'center',
              fontSize: '1.3rem',
              color: '#6c7786',
            }}
          >
            Add
          </span>
        </div>
      </div>
      <div style={{ width: '20%', padding: '0.5rem' }}>
        <div
          style={{
            height: '100%',
            padding: '1rem',
            border: '1px solid #c5c9ce',
            borderRadius: 5,
          }}
        >
          <div style={{ display: 'flex', justifyContent: 'center' }}>
            <Icons.AddButton />
          </div>
          <span
            style={{
              display: 'block',
              paddingTop: '1rem',
              textAlign: 'center',
              fontSize: '1.3rem',
              color: '#6c7786',
            }}
          >
            AddButton
          </span>
        </div>
      </div>
      <div style={{ width: '20%', padding: '0.5rem' }}>
        <div
          style={{
            height: '100%',
            padding: '1rem',
            border: '1px solid #c5c9ce',
            borderRadius: 5,
          }}
        >
          <div style={{ display: 'flex', justifyContent: 'center' }}>
            <Icons.AddButtonAlt />
          </div>
          <span
            style={{
              display: 'block',
              paddingTop: '1rem',
              textAlign: 'center',
              fontSize: '1.3rem',
              color: '#6c7786',
            }}
          >
            AddButtonAlt
          </span>
        </div>
      </div>
      <div style={{ width: '20%', padding: '0.5rem' }}>
        <div
          style={{
            height: '100%',
            padding: '1rem',
            border: '1px solid #c5c9ce',
            borderRadius: 5,
          }}
        >
          <div style={{ display: 'flex', justifyContent: 'center' }}>
            <Icons.AddTransaction />
          </div>
          <span
            style={{
              display: 'block',
              paddingTop: '1rem',
              textAlign: 'center',
              fontSize: '1.3rem',
              color: '#6c7786',
            }}
          >
            AddTransaction
          </span>
        </div>
      </div>
      <div style={{ width: '20%', padding: '0.5rem' }}>
        <div
          style={{
            height: '100%',
            padding: '1rem',
            border: '1px solid #c5c9ce',
            borderRadius: 5,
          }}
        >
          <div style={{ display: 'flex', justifyContent: 'center' }}>
            <Icons.Alert />
          </div>
          <span
            style={{
              display: 'block',
              paddingTop: '1rem',
              textAlign: 'center',
              fontSize: '1.3rem',
              color: '#6c7786',
            }}
          >
            Alert
          </span>
        </div>
      </div>
      <div style={{ width: '20%', padding: '0.5rem' }}>
        <div
          style={{
            height: '100%',
            padding: '1rem',
            border: '1px solid #c5c9ce',
            borderRadius: 5,
          }}
        >
          <div style={{ display: 'flex', justifyContent: 'center' }}>
            <Icons.Admin />
          </div>
          <span
            style={{
              display: 'block',
              paddingTop: '1rem',
              textAlign: 'center',
              fontSize: '1.3rem',
              color: '#6c7786',
            }}
          >
            Admin
          </span>
        </div>
      </div>
      <div style={{ width: '20%', padding: '0.5rem' }}>
        <div
          style={{
            height: '100%',
            padding: '1rem',
            border: '1px solid #c5c9ce',
            borderRadius: 5,
          }}
        >
          <div style={{ display: 'flex', justifyContent: 'center' }}>
            <Icons.ArrowBackMobile />
          </div>
          <span
            style={{
              display: 'block',
              paddingTop: '1rem',
              textAlign: 'center',
              fontSize: '1.3rem',
              color: '#6c7786',
            }}
          >
            ArrowBackMobile
          </span>
        </div>
      </div>
      <div style={{ width: '20%', padding: '0.5rem' }}>
        <div
          style={{
            height: '100%',
            padding: '1rem',
            border: '1px solid #c5c9ce',
            borderRadius: 5,
          }}
        >
          <div style={{ display: 'flex', justifyContent: 'center' }}>
            <Icons.ArrowBackPanel />
          </div>
          <span
            style={{
              display: 'block',
              paddingTop: '1rem',
              textAlign: 'center',
              fontSize: '1.3rem',
              color: '#6c7786',
            }}
          >
            ArrowBackPanel
          </span>
        </div>
      </div>
      <div style={{ width: '20%', padding: '0.5rem' }}>
        <div
          style={{
            height: '100%',
            padding: '1rem',
            border: '1px solid #c5c9ce',
            borderRadius: 5,
          }}
        >
          <div style={{ display: 'flex', justifyContent: 'center' }}>
            <Icons.ArrowButton />
          </div>
          <span
            style={{
              display: 'block',
              paddingTop: '1rem',
              textAlign: 'center',
              fontSize: '1.3rem',
              color: '#6c7786',
            }}
          >
            ArrowButton
          </span>
        </div>
      </div>
      <div style={{ width: '20%', padding: '0.5rem' }}>
        <div
          style={{
            height: '100%',
            padding: '1rem',
            border: '1px solid #c5c9ce',
            borderRadius: 5,
          }}
        >
          <div style={{ display: 'flex', justifyContent: 'center' }}>
            <Icons.ArrowDown />
          </div>
          <span
            style={{
              display: 'block',
              paddingTop: '1rem',
              textAlign: 'center',
              fontSize: '1.3rem',
              color: '#6c7786',
            }}
          >
            ArrowDown
          </span>
        </div>
      </div>
      <div style={{ width: '20%', padding: '0.5rem' }}>
        <div
          style={{
            height: '100%',
            padding: '1rem',
            border: '1px solid #c5c9ce',
            borderRadius: 5,
          }}
        >
          <div style={{ display: 'flex', justifyContent: 'center' }}>
            <Icons.ArrowDownMobileFilter />
          </div>
          <span
            style={{
              display: 'block',
              paddingTop: '1rem',
              textAlign: 'center',
              fontSize: '1.3rem',
              color: '#6c7786',
            }}
          >
            ArrowDownMobileFilter
          </span>
        </div>
      </div>
      <div style={{ width: '20%', padding: '0.5rem' }}>
        <div
          style={{
            height: '100%',
            padding: '1rem',
            border: '1px solid #c5c9ce',
            borderRadius: 5,
          }}
        >
          <div style={{ display: 'flex', justifyContent: 'center' }}>
            <Icons.ArrowUp />
          </div>
          <span
            style={{
              display: 'block',
              paddingTop: '1rem',
              textAlign: 'center',
              fontSize: '1.3rem',
              color: '#6c7786',
            }}
          >
            ArrowUp
          </span>
        </div>
      </div>
      <div style={{ width: '20%', padding: '0.5rem' }}>
        <div
          style={{
            height: '100%',
            padding: '1rem',
            border: '1px solid #c5c9ce',
            borderRadius: 5,
          }}
        >
          <div style={{ display: 'flex', justifyContent: 'center' }}>
            <Icons.ArrowDownMobile />
          </div>
          <span
            style={{
              display: 'block',
              paddingTop: '1rem',
              textAlign: 'center',
              fontSize: '1.3rem',
              color: '#6c7786',
            }}
          >
            ArrowDownMobile
          </span>
        </div>
      </div>
      <div style={{ width: '20%', padding: '0.5rem' }}>
        <div
          style={{
            height: '100%',
            padding: '1rem',
            border: '1px solid #c5c9ce',
            borderRadius: 5,
          }}
        >
          <div style={{ display: 'flex', justifyContent: 'center' }}>
            <Icons.ArrowRight />
          </div>
          <span
            style={{
              display: 'block',
              paddingTop: '1rem',
              textAlign: 'center',
              fontSize: '1.3rem',
              color: '#6c7786',
            }}
          >
            ArrowRight
          </span>
        </div>
      </div>
      <div style={{ width: '20%', padding: '0.5rem' }}>
        <div
          style={{
            height: '100%',
            padding: '1rem',
            border: '1px solid #c5c9ce',
            borderRadius: 5,
          }}
        >
          <div style={{ display: 'flex', justifyContent: 'center' }}>
            <Icons.ArrowLeftMobile />
          </div>
          <span
            style={{
              display: 'block',
              paddingTop: '1rem',
              textAlign: 'center',
              fontSize: '1.3rem',
              color: '#6c7786',
            }}
          >
            ArrowLeftMobile
          </span>
        </div>
      </div>
      <div style={{ width: '20%', padding: '0.5rem' }}>
        <div
          style={{
            height: '100%',
            padding: '1rem',
            border: '1px solid #c5c9ce',
            borderRadius: 5,
          }}
        >
          <div style={{ display: 'flex', justifyContent: 'center' }}>
            <Icons.ArrowRightMobile />
          </div>
          <span
            style={{
              display: 'block',
              paddingTop: '1rem',
              textAlign: 'center',
              fontSize: '1.3rem',
              color: '#6c7786',
            }}
          >
            ArrowRightMobile
          </span>
        </div>
      </div>
      <div style={{ width: '20%', padding: '0.5rem' }}>
        <div
          style={{
            height: '100%',
            padding: '1rem',
            border: '1px solid #c5c9ce',
            borderRadius: 5,
          }}
        >
          <div style={{ display: 'flex', justifyContent: 'center' }}>
            <Icons.ArrowFooter />
          </div>
          <span
            style={{
              display: 'block',
              paddingTop: '1rem',
              textAlign: 'center',
              fontSize: '1.3rem',
              color: '#6c7786',
            }}
          >
            ArrowFooter
          </span>
        </div>
      </div>
      <div style={{ width: '20%', padding: '0.5rem' }}>
        <div
          style={{
            height: '100%',
            padding: '1rem',
            border: '1px solid #c5c9ce',
            borderRadius: 5,
          }}
        >
          <div style={{ display: 'flex', justifyContent: 'center' }}>
            <Icons.CardAddress />
          </div>
          <span
            style={{
              display: 'block',
              paddingTop: '1rem',
              textAlign: 'center',
              fontSize: '1.3rem',
              color: '#6c7786',
            }}
          >
            CardAddress
          </span>
        </div>
      </div>
      <div style={{ width: '20%', padding: '0.5rem' }}>
        <div
          style={{
            height: '100%',
            padding: '1rem',
            border: '1px solid #c5c9ce',
            borderRadius: 5,
          }}
        >
          <div style={{ display: 'flex', justifyContent: 'center' }}>
            <Icons.CardDetails />
          </div>
          <span
            style={{
              display: 'block',
              paddingTop: '1rem',
              textAlign: 'center',
              fontSize: '1.3rem',
              color: '#6c7786',
            }}
          >
            CardDetails
          </span>
        </div>
      </div>
      <div style={{ width: '20%', padding: '0.5rem' }}>
        <div
          style={{
            height: '100%',
            padding: '1rem',
            border: '1px solid #c5c9ce',
            borderRadius: 5,
          }}
        >
          <div style={{ display: 'flex', justifyContent: 'center' }}>
            <Icons.CardFavorite />
          </div>
          <span
            style={{
              display: 'block',
              paddingTop: '1rem',
              textAlign: 'center',
              fontSize: '1.3rem',
              color: '#6c7786',
            }}
          >
            CardFavorite
          </span>
        </div>
      </div>
      <div style={{ width: '20%', padding: '0.5rem' }}>
        <div
          style={{
            height: '100%',
            padding: '1rem',
            border: '1px solid #c5c9ce',
            borderRadius: 5,
          }}
        >
          <div style={{ display: 'flex', justifyContent: 'center' }}>
            <Icons.CarouselPrevious />
          </div>
          <span
            style={{
              display: 'block',
              paddingTop: '1rem',
              textAlign: 'center',
              fontSize: '1.3rem',
              color: '#6c7786',
            }}
          >
            CarouselPrevious
          </span>
        </div>
      </div>
      <div style={{ width: '20%', padding: '0.5rem' }}>
        <div
          style={{
            height: '100%',
            padding: '1rem',
            border: '1px solid #c5c9ce',
            borderRadius: 5,
          }}
        >
          <div style={{ display: 'flex', justifyContent: 'center' }}>
            <Icons.CarouselNext />
          </div>
          <span
            style={{
              display: 'block',
              paddingTop: '1rem',
              textAlign: 'center',
              fontSize: '1.3rem',
              color: '#6c7786',
            }}
          >
            CarouselNext
          </span>
        </div>
      </div>
      <div style={{ width: '20%', padding: '0.5rem' }}>
        <div
          style={{
            height: '100%',
            padding: '1rem',
            border: '1px solid #c5c9ce',
            borderRadius: 5,
          }}
        >
          <div style={{ display: 'flex', justifyContent: 'center' }}>
            <Icons.Calendar />
          </div>
          <span
            style={{
              display: 'block',
              paddingTop: '1rem',
              textAlign: 'center',
              fontSize: '1.3rem',
              color: '#6c7786',
            }}
          >
            Calendar
          </span>
        </div>
      </div>
      <div style={{ width: '20%', padding: '0.5rem' }}>
        <div
          style={{
            height: '100%',
            padding: '1rem',
            border: '1px solid #c5c9ce',
            borderRadius: 5,
          }}
        >
          <div style={{ display: 'flex', justifyContent: 'center' }}>
            <Icons.CalendarEdit />
          </div>
          <span
            style={{
              display: 'block',
              paddingTop: '1rem',
              textAlign: 'center',
              fontSize: '1.3rem',
              color: '#6c7786',
            }}
          >
            CalendarEdit
          </span>
        </div>
      </div>
      <div style={{ width: '20%', padding: '0.5rem' }}>
        <div
          style={{
            height: '100%',
            padding: '1rem',
            border: '1px solid #c5c9ce',
            borderRadius: 5,
          }}
        >
          <div style={{ display: 'flex', justifyContent: 'center' }}>
            <Icons.CardPlastic />
          </div>
          <span
            style={{
              display: 'block',
              paddingTop: '1rem',
              textAlign: 'center',
              fontSize: '1.3rem',
              color: '#6c7786',
            }}
          >
            CardPlastic
          </span>
        </div>
      </div>
      <div style={{ width: '20%', padding: '0.5rem' }}>
        <div
          style={{
            height: '100%',
            padding: '1rem',
            border: '1px solid #c5c9ce',
            borderRadius: 5,
          }}
        >
          <div style={{ display: 'flex', justifyContent: 'center' }}>
            <Icons.CardVirtual />
          </div>
          <span
            style={{
              display: 'block',
              paddingTop: '1rem',
              textAlign: 'center',
              fontSize: '1.3rem',
              color: '#6c7786',
            }}
          >
            CardVirtual
          </span>
        </div>
      </div>
      <div style={{ width: '20%', padding: '0.5rem' }}>
        <div
          style={{
            height: '100%',
            padding: '1rem',
            border: '1px solid #c5c9ce',
            borderRadius: 5,
          }}
        >
          <div style={{ display: 'flex', justifyContent: 'center' }}>
            <Icons.Cards />
          </div>
          <span
            style={{
              display: 'block',
              paddingTop: '1rem',
              textAlign: 'center',
              fontSize: '1.3rem',
              color: '#6c7786',
            }}
          >
            Cards
          </span>
        </div>
      </div>
      <div style={{ width: '20%', padding: '0.5rem' }}>
        <div
          style={{
            height: '100%',
            padding: '1rem',
            border: '1px solid #c5c9ce',
            borderRadius: 5,
          }}
        >
          <div style={{ display: 'flex', justifyContent: 'center' }}>
            <Icons.CardTransactionTopup />
          </div>
          <span
            style={{
              display: 'block',
              paddingTop: '1rem',
              textAlign: 'center',
              fontSize: '1.3rem',
              color: '#6c7786',
            }}
          >
            CardTransactionTopup
          </span>
        </div>
      </div>
      <div style={{ width: '20%', padding: '0.5rem' }}>
        <div
          style={{
            height: '100%',
            padding: '1rem',
            border: '1px solid #c5c9ce',
            borderRadius: 5,
          }}
        >
          <div style={{ display: 'flex', justifyContent: 'center' }}>
            <Icons.CardTransactionBlue />
          </div>
          <span
            style={{
              display: 'block',
              paddingTop: '1rem',
              textAlign: 'center',
              fontSize: '1.3rem',
              color: '#6c7786',
            }}
          >
            CardTransactionBlue
          </span>
        </div>
      </div>
      <div style={{ width: '20%', padding: '0.5rem' }}>
        <div
          style={{
            height: '100%',
            padding: '1rem',
            border: '1px solid #c5c9ce',
            borderRadius: 5,
          }}
        >
          <div style={{ display: 'flex', justifyContent: 'center' }}>
            <Icons.CardTransactionCultural />
          </div>
          <span
            style={{
              display: 'block',
              paddingTop: '1rem',
              textAlign: 'center',
              fontSize: '1.3rem',
              color: '#6c7786',
            }}
          >
            CardTransactionCultural
          </span>
        </div>
      </div>
      <div style={{ width: '20%', padding: '0.5rem' }}>
        <div
          style={{
            height: '100%',
            padding: '1rem',
            border: '1px solid #c5c9ce',
            borderRadius: 5,
          }}
        >
          <div style={{ display: 'flex', justifyContent: 'center' }}>
            <Icons.CardTransactionGift />
          </div>
          <span
            style={{
              display: 'block',
              paddingTop: '1rem',
              textAlign: 'center',
              fontSize: '1.3rem',
              color: '#6c7786',
            }}
          >
            CardTransactionGift
          </span>
        </div>
      </div>
      <div style={{ width: '20%', padding: '0.5rem' }}>
        <div
          style={{
            height: '100%',
            padding: '1rem',
            border: '1px solid #c5c9ce',
            borderRadius: 5,
          }}
        >
          <div style={{ display: 'flex', justifyContent: 'center' }}>
            <Icons.CardTransactionMeal />
          </div>
          <span
            style={{
              display: 'block',
              paddingTop: '1rem',
              textAlign: 'center',
              fontSize: '1.3rem',
              color: '#6c7786',
            }}
          >
            CardTransactionMeal
          </span>
        </div>
      </div>
      <div style={{ width: '20%', padding: '0.5rem' }}>
        <div
          style={{
            height: '100%',
            padding: '1rem',
            border: '1px solid #c5c9ce',
            borderRadius: 5,
          }}
        >
          <div style={{ display: 'flex', justifyContent: 'center' }}>
            <Icons.CardTransactionVacation />
          </div>
          <span
            style={{
              display: 'block',
              paddingTop: '1rem',
              textAlign: 'center',
              fontSize: '1.3rem',
              color: '#6c7786',
            }}
          >
            CardTransactionVacation
          </span>
        </div>
      </div>
      <div style={{ width: '20%', padding: '0.5rem' }}>
        <div
          style={{
            height: '100%',
            padding: '1rem',
            border: '1px solid #c5c9ce',
            borderRadius: 5,
          }}
        >
          <div style={{ display: 'flex', justifyContent: 'center' }}>
            <Icons.Cashback />
          </div>
          <span
            style={{
              display: 'block',
              paddingTop: '1rem',
              textAlign: 'center',
              fontSize: '1.3rem',
              color: '#6c7786',
            }}
          >
            Cashback
          </span>
        </div>
      </div>
      <div style={{ width: '20%', padding: '0.5rem' }}>
        <div
          style={{
            height: '100%',
            padding: '1rem',
            border: '1px solid #c5c9ce',
            borderRadius: 5,
          }}
        >
          <div style={{ display: 'flex', justifyContent: 'center' }}>
            <Icons.Check />
          </div>
          <span
            style={{
              display: 'block',
              paddingTop: '1rem',
              textAlign: 'center',
              fontSize: '1.3rem',
              color: '#6c7786',
            }}
          >
            Check
          </span>
        </div>
      </div>
      <div style={{ width: '20%', padding: '0.5rem' }}>
        <div
          style={{
            height: '100%',
            padding: '1rem',
            border: '1px solid #c5c9ce',
            borderRadius: 5,
          }}
        >
          <div style={{ display: 'flex', justifyContent: 'center' }}>
            <Icons.CheckAlt />
          </div>
          <span
            style={{
              display: 'block',
              paddingTop: '1rem',
              textAlign: 'center',
              fontSize: '1.3rem',
              color: '#6c7786',
            }}
          >
            CheckAlt
          </span>
        </div>
      </div>
      <div style={{ width: '20%', padding: '0.5rem' }}>
        <div
          style={{
            height: '100%',
            padding: '1rem',
            border: '1px solid #c5c9ce',
            borderRadius: 5,
          }}
        >
          <div style={{ display: 'flex', justifyContent: 'center' }}>
            <Icons.Checklist />
          </div>
          <span
            style={{
              display: 'block',
              paddingTop: '1rem',
              textAlign: 'center',
              fontSize: '1.3rem',
              color: '#6c7786',
            }}
          >
            Checklist
          </span>
        </div>
      </div>
      <div style={{ width: '20%', padding: '0.5rem' }}>
        <div
          style={{
            height: '100%',
            padding: '1rem',
            border: '1px solid #c5c9ce',
            borderRadius: 5,
          }}
        >
          <div style={{ display: 'flex', justifyContent: 'center' }}>
            <Icons.ClearFilters />
          </div>
          <span
            style={{
              display: 'block',
              paddingTop: '1rem',
              textAlign: 'center',
              fontSize: '1.3rem',
              color: '#6c7786',
            }}
          >
            ClearFilters
          </span>
        </div>
      </div>
      <div style={{ width: '20%', padding: '0.5rem' }}>
        <div
          style={{
            height: '100%',
            padding: '1rem',
            border: '1px solid #c5c9ce',
            borderRadius: 5,
          }}
        >
          <div style={{ display: 'flex', justifyContent: 'center' }}>
            <Icons.CloseDelete />
          </div>
          <span
            style={{
              display: 'block',
              paddingTop: '1rem',
              textAlign: 'center',
              fontSize: '1.3rem',
              color: '#6c7786',
            }}
          >
            CloseDelete
          </span>
        </div>
      </div>
      <div style={{ width: '20%', padding: '0.5rem' }}>
        <div
          style={{
            height: '100%',
            padding: '1rem',
            border: '1px solid #c5c9ce',
            borderRadius: 5,
          }}
        >
          <div style={{ display: 'flex', justifyContent: 'center' }}>
            <Icons.Cog />
          </div>
          <span
            style={{
              display: 'block',
              paddingTop: '1rem',
              textAlign: 'center',
              fontSize: '1.3rem',
              color: '#6c7786',
            }}
          >
            Cog
          </span>
        </div>
      </div>
      <div style={{ width: '20%', padding: '0.5rem' }}>
        <div
          style={{
            height: '100%',
            padding: '1rem',
            border: '1px solid #c5c9ce',
            borderRadius: 5,
          }}
        >
          <div style={{ display: 'flex', justifyContent: 'center' }}>
            <Icons.CopyIcon />
          </div>
          <span
            style={{
              display: 'block',
              paddingTop: '1rem',
              textAlign: 'center',
              fontSize: '1.3rem',
              color: '#6c7786',
            }}
          >
            CopyIcon
          </span>
        </div>
      </div>
      <div style={{ width: '20%', padding: '0.5rem' }}>
        <div
          style={{
            height: '100%',
            padding: '1rem',
            border: '1px solid #c5c9ce',
            borderRadius: 5,
          }}
        >
          <div style={{ display: 'flex', justifyContent: 'center' }}>
            <Icons.CopyIconSmall />
          </div>
          <span
            style={{
              display: 'block',
              paddingTop: '1rem',
              textAlign: 'center',
              fontSize: '1.3rem',
              color: '#6c7786',
            }}
          >
            CopyIconSmall
          </span>
        </div>
      </div>
      <div style={{ width: '20%', padding: '0.5rem' }}>
        <div
          style={{
            height: '100%',
            padding: '1rem',
            border: '1px solid #c5c9ce',
            borderRadius: 5,
          }}
        >
          <div style={{ display: 'flex', justifyContent: 'center' }}>
            <Icons.Copy />
          </div>
          <span
            style={{
              display: 'block',
              paddingTop: '1rem',
              textAlign: 'center',
              fontSize: '1.3rem',
              color: '#6c7786',
            }}
          >
            Copy
          </span>
        </div>
      </div>
      <div style={{ width: '20%', padding: '0.5rem' }}>
        <div
          style={{
            height: '100%',
            padding: '1rem',
            border: '1px solid #c5c9ce',
            borderRadius: 5,
          }}
        >
          <div style={{ display: 'flex', justifyContent: 'center' }}>
            <Icons.Dashboard />
          </div>
          <span
            style={{
              display: 'block',
              paddingTop: '1rem',
              textAlign: 'center',
              fontSize: '1.3rem',
              color: '#6c7786',
            }}
          >
            Dashboard
          </span>
        </div>
      </div>
      <div style={{ width: '20%', padding: '0.5rem' }}>
        <div
          style={{
            height: '100%',
            padding: '1rem',
            border: '1px solid #c5c9ce',
            borderRadius: 5,
          }}
        >
          <div style={{ display: 'flex', justifyContent: 'center' }}>
            <Icons.DashboardCircle />
          </div>
          <span
            style={{
              display: 'block',
              paddingTop: '1rem',
              textAlign: 'center',
              fontSize: '1.3rem',
              color: '#6c7786',
            }}
          >
            DashboardCircle
          </span>
        </div>
      </div>
      <div style={{ width: '20%', padding: '0.5rem' }}>
        <div
          style={{
            height: '100%',
            padding: '1rem',
            border: '1px solid #c5c9ce',
            borderRadius: 5,
          }}
        >
          <div style={{ display: 'flex', justifyContent: 'center' }}>
            <Icons.Delete />
          </div>
          <span
            style={{
              display: 'block',
              paddingTop: '1rem',
              textAlign: 'center',
              fontSize: '1.3rem',
              color: '#6c7786',
            }}
          >
            Delete
          </span>
        </div>
      </div>
      <div style={{ width: '20%', padding: '0.5rem' }}>
        <div
          style={{
            height: '100%',
            padding: '1rem',
            border: '1px solid #c5c9ce',
            borderRadius: 5,
          }}
        >
          <div style={{ display: 'flex', justifyContent: 'center' }}>
            <Icons.DeleteButton />
          </div>
          <span
            style={{
              display: 'block',
              paddingTop: '1rem',
              textAlign: 'center',
              fontSize: '1.3rem',
              color: '#6c7786',
            }}
          >
            DeleteButton
          </span>
        </div>
      </div>
      <div style={{ width: '20%', padding: '0.5rem' }}>
        <div
          style={{
            height: '100%',
            padding: '1rem',
            border: '1px solid #c5c9ce',
            borderRadius: 5,
          }}
        >
          <div style={{ display: 'flex', justifyContent: 'center' }}>
            <Icons.DeleteSmall />
          </div>
          <span
            style={{
              display: 'block',
              paddingTop: '1rem',
              textAlign: 'center',
              fontSize: '1.3rem',
              color: '#6c7786',
            }}
          >
            DeleteSmall
          </span>
        </div>
      </div>
      <div style={{ width: '20%', padding: '0.5rem' }}>
        <div
          style={{
            height: '100%',
            padding: '1rem',
            border: '1px solid #c5c9ce',
            borderRadius: 5,
          }}
        >
          <div style={{ display: 'flex', justifyContent: 'center' }}>
            <Icons.DialogBenefitTip />
          </div>
          <span
            style={{
              display: 'block',
              paddingTop: '1rem',
              textAlign: 'center',
              fontSize: '1.3rem',
              color: '#6c7786',
            }}
          >
            DialogBenefitTip
          </span>
        </div>
      </div>
      <div style={{ width: '20%', padding: '0.5rem' }}>
        <div
          style={{
            height: '100%',
            padding: '1rem',
            border: '1px solid #c5c9ce',
            borderRadius: 5,
          }}
        >
          <div style={{ display: 'flex', justifyContent: 'center' }}>
            <Icons.DialogFunds />
          </div>
          <span
            style={{
              display: 'block',
              paddingTop: '1rem',
              textAlign: 'center',
              fontSize: '1.3rem',
              color: '#6c7786',
            }}
          >
            DialogFunds
          </span>
        </div>
      </div>
      <div style={{ width: '20%', padding: '0.5rem' }}>
        <div
          style={{
            height: '100%',
            padding: '1rem',
            border: '1px solid #c5c9ce',
            borderRadius: 5,
          }}
        >
          <div style={{ display: 'flex', justifyContent: 'center' }}>
            <Icons.DownloadComputer />
          </div>
          <span
            style={{
              display: 'block',
              paddingTop: '1rem',
              textAlign: 'center',
              fontSize: '1.3rem',
              color: '#6c7786',
            }}
          >
            DownloadComputer
          </span>
        </div>
      </div>
      <div style={{ width: '20%', padding: '0.5rem' }}>
        <div
          style={{
            height: '100%',
            padding: '1rem',
            border: '1px solid #c5c9ce',
            borderRadius: 5,
          }}
        >
          <div style={{ display: 'flex', justifyContent: 'center' }}>
            <Icons.DownloadFile />
          </div>
          <span
            style={{
              display: 'block',
              paddingTop: '1rem',
              textAlign: 'center',
              fontSize: '1.3rem',
              color: '#6c7786',
            }}
          >
            DownloadFile
          </span>
        </div>
      </div>
      <div style={{ width: '20%', padding: '0.5rem' }}>
        <div
          style={{
            height: '100%',
            padding: '1rem',
            border: '1px solid #c5c9ce',
            borderRadius: 5,
          }}
        >
          <div style={{ display: 'flex', justifyContent: 'center' }}>
            <Icons.Drag />
          </div>
          <span
            style={{
              display: 'block',
              paddingTop: '1rem',
              textAlign: 'center',
              fontSize: '1.3rem',
              color: '#6c7786',
            }}
          >
            Drag
          </span>
        </div>
      </div>
      <div style={{ width: '20%', padding: '0.5rem' }}>
        <div
          style={{
            height: '100%',
            padding: '1rem',
            border: '1px solid #c5c9ce',
            borderRadius: 5,
          }}
        >
          <div style={{ display: 'flex', justifyContent: 'center' }}>
            <Icons.Edit />
          </div>
          <span
            style={{
              display: 'block',
              paddingTop: '1rem',
              textAlign: 'center',
              fontSize: '1.3rem',
              color: '#6c7786',
            }}
          >
            Edit
          </span>
        </div>
      </div>
      <div style={{ width: '20%', padding: '0.5rem' }}>
        <div
          style={{
            height: '100%',
            padding: '1rem',
            border: '1px solid #c5c9ce',
            borderRadius: 5,
          }}
        >
          <div style={{ display: 'flex', justifyContent: 'center' }}>
            <Icons.EditBig />
          </div>
          <span
            style={{
              display: 'block',
              paddingTop: '1rem',
              textAlign: 'center',
              fontSize: '1.3rem',
              color: '#6c7786',
            }}
          >
            EditBig
          </span>
        </div>
      </div>
      <div style={{ width: '20%', padding: '0.5rem' }}>
        <div
          style={{
            height: '100%',
            padding: '1rem',
            border: '1px solid #c5c9ce',
            borderRadius: 5,
          }}
        >
          <div style={{ display: 'flex', justifyContent: 'center' }}>
            <Icons.Employees />
          </div>
          <span
            style={{
              display: 'block',
              paddingTop: '1rem',
              textAlign: 'center',
              fontSize: '1.3rem',
              color: '#6c7786',
            }}
          >
            Employees
          </span>
        </div>
      </div>
      <div style={{ width: '20%', padding: '0.5rem' }}>
        <div
          style={{
            height: '100%',
            padding: '1rem',
            border: '1px solid #c5c9ce',
            borderRadius: 5,
          }}
        >
          <div style={{ display: 'flex', justifyContent: 'center' }}>
            <Icons.Favorite />
          </div>
          <span
            style={{
              display: 'block',
              paddingTop: '1rem',
              textAlign: 'center',
              fontSize: '1.3rem',
              color: '#6c7786',
            }}
          >
            Favorite
          </span>
        </div>
      </div>
      <div style={{ width: '20%', padding: '0.5rem' }}>
        <div
          style={{
            height: '100%',
            padding: '1rem',
            border: '1px solid #c5c9ce',
            borderRadius: 5,
          }}
        >
          <div style={{ display: 'flex', justifyContent: 'center' }}>
            <Icons.Gift />
          </div>
          <span
            style={{
              display: 'block',
              paddingTop: '1rem',
              textAlign: 'center',
              fontSize: '1.3rem',
              color: '#6c7786',
            }}
          >
            Gift
          </span>
        </div>
      </div>
      <div style={{ width: '20%', padding: '0.5rem' }}>
        <div
          style={{
            height: '100%',
            padding: '1rem',
            border: '1px solid #c5c9ce',
            borderRadius: 5,
          }}
        >
          <div style={{ display: 'flex', justifyContent: 'center' }}>
            <Icons.Heart />
          </div>
          <span
            style={{
              display: 'block',
              paddingTop: '1rem',
              textAlign: 'center',
              fontSize: '1.3rem',
              color: '#6c7786',
            }}
          >
            Heart
          </span>
        </div>
      </div>
      <div style={{ width: '20%', padding: '0.5rem' }}>
        <div
          style={{
            height: '100%',
            padding: '1rem',
            border: '1px solid #c5c9ce',
            borderRadius: 5,
          }}
        >
          <div style={{ display: 'flex', justifyContent: 'center' }}>
            <Icons.HeartButton />
          </div>
          <span
            style={{
              display: 'block',
              paddingTop: '1rem',
              textAlign: 'center',
              fontSize: '1.3rem',
              color: '#6c7786',
            }}
          >
            HeartButton
          </span>
        </div>
      </div>
      <div style={{ width: '20%', padding: '0.5rem' }}>
        <div
          style={{
            height: '100%',
            padding: '1rem',
            border: '1px solid #c5c9ce',
            borderRadius: 5,
          }}
        >
          <div style={{ display: 'flex', justifyContent: 'center' }}>
            <Icons.Help />
          </div>
          <span
            style={{
              display: 'block',
              paddingTop: '1rem',
              textAlign: 'center',
              fontSize: '1.3rem',
              color: '#6c7786',
            }}
          >
            Help
          </span>
        </div>
      </div>
      <div style={{ width: '20%', padding: '0.5rem' }}>
        <div
          style={{
            height: '100%',
            padding: '1rem',
            border: '1px solid #c5c9ce',
            borderRadius: 5,
          }}
        >
          <div style={{ display: 'flex', justifyContent: 'center' }}>
            <Icons.Home />
          </div>
          <span
            style={{
              display: 'block',
              paddingTop: '1rem',
              textAlign: 'center',
              fontSize: '1.3rem',
              color: '#6c7786',
            }}
          >
            Home
          </span>
        </div>
      </div>
      <div style={{ width: '20%', padding: '0.5rem' }}>
        <div
          style={{
            height: '100%',
            padding: '1rem',
            border: '1px solid #c5c9ce',
            borderRadius: 5,
          }}
        >
          <div style={{ display: 'flex', justifyContent: 'center' }}>
            <Icons.Info />
          </div>
          <span
            style={{
              display: 'block',
              paddingTop: '1rem',
              textAlign: 'center',
              fontSize: '1.3rem',
              color: '#6c7786',
            }}
          >
            Info
          </span>
        </div>
      </div>
      <div style={{ width: '20%', padding: '0.5rem' }}>
        <div
          style={{
            height: '100%',
            padding: '1rem',
            border: '1px solid #c5c9ce',
            borderRadius: 5,
          }}
        >
          <div style={{ display: 'flex', justifyContent: 'center' }}>
            <Icons.InfoBlue />
          </div>
          <span
            style={{
              display: 'block',
              paddingTop: '1rem',
              textAlign: 'center',
              fontSize: '1.3rem',
              color: '#6c7786',
            }}
          >
            InfoBlue
          </span>
        </div>
      </div>
      <div style={{ width: '20%', padding: '0.5rem' }}>
        <div
          style={{
            height: '100%',
            padding: '1rem',
            border: '1px solid #c5c9ce',
            borderRadius: 5,
          }}
        >
          <div style={{ display: 'flex', justifyContent: 'center' }}>
            <Icons.InfoDashboard />
          </div>
          <span
            style={{
              display: 'block',
              paddingTop: '1rem',
              textAlign: 'center',
              fontSize: '1.3rem',
              color: '#6c7786',
            }}
          >
            InfoDashboard
          </span>
        </div>
      </div>
      <div style={{ width: '20%', padding: '0.5rem' }}>
        <div
          style={{
            height: '100%',
            padding: '1rem',
            border: '1px solid #c5c9ce',
            borderRadius: 5,
          }}
        >
          <div style={{ display: 'flex', justifyContent: 'center' }}>
            <Icons.InfoSmall />
          </div>
          <span
            style={{
              display: 'block',
              paddingTop: '1rem',
              textAlign: 'center',
              fontSize: '1.3rem',
              color: '#6c7786',
            }}
          >
            InfoSmall
          </span>
        </div>
      </div>
      <div style={{ width: '20%', padding: '0.5rem' }}>
        <div
          style={{
            height: '100%',
            padding: '1rem',
            border: '1px solid #c5c9ce',
            borderRadius: 5,
          }}
        >
          <div style={{ display: 'flex', justifyContent: 'center' }}>
            <Icons.InfoMedium />
          </div>
          <span
            style={{
              display: 'block',
              paddingTop: '1rem',
              textAlign: 'center',
              fontSize: '1.3rem',
              color: '#6c7786',
            }}
          >
            InfoMedium
          </span>
        </div>
      </div>
      <div style={{ width: '20%', padding: '0.5rem' }}>
        <div
          style={{
            height: '100%',
            padding: '1rem',
            border: '1px solid #c5c9ce',
            borderRadius: 5,
          }}
        >
          <div style={{ display: 'flex', justifyContent: 'center' }}>
            <Icons.Invisible />
          </div>
          <span
            style={{
              display: 'block',
              paddingTop: '1rem',
              textAlign: 'center',
              fontSize: '1.3rem',
              color: '#6c7786',
            }}
          >
            Invisible
          </span>
        </div>
      </div>
      <div style={{ width: '20%', padding: '0.5rem' }}>
        <div
          style={{
            height: '100%',
            padding: '1rem',
            border: '1px solid #c5c9ce',
            borderRadius: 5,
          }}
        >
          <div style={{ display: 'flex', justifyContent: 'center' }}>
            <Icons.Language />
          </div>
          <span
            style={{
              display: 'block',
              paddingTop: '1rem',
              textAlign: 'center',
              fontSize: '1.3rem',
              color: '#6c7786',
            }}
          >
            Language
          </span>
        </div>
      </div>
      <div style={{ width: '20%', padding: '0.5rem' }}>
        <div
          style={{
            height: '100%',
            padding: '1rem',
            border: '1px solid #c5c9ce',
            borderRadius: 5,
          }}
        >
          <div style={{ display: 'flex', justifyContent: 'center' }}>
            <Icons.Logout />
          </div>
          <span
            style={{
              display: 'block',
              paddingTop: '1rem',
              textAlign: 'center',
              fontSize: '1.3rem',
              color: '#6c7786',
            }}
          >
            Logout
          </span>
        </div>
      </div>
      <div style={{ width: '20%', padding: '0.5rem' }}>
        <div
          style={{
            height: '100%',
            padding: '1rem',
            border: '1px solid #c5c9ce',
            borderRadius: 5,
          }}
        >
          <div style={{ display: 'flex', justifyContent: 'center' }}>
            <Icons.Loading />
          </div>
          <span
            style={{
              display: 'block',
              paddingTop: '1rem',
              textAlign: 'center',
              fontSize: '1.3rem',
              color: '#6c7786',
            }}
          >
            Loading
          </span>
        </div>
      </div>
      <div style={{ width: '20%', padding: '0.5rem' }}>
        <div
          style={{
            height: '100%',
            padding: '1rem',
            border: '1px solid #c5c9ce',
            borderRadius: 5,
          }}
        >
          <div style={{ display: 'flex', justifyContent: 'center' }}>
            <Icons.MarkAll />
          </div>
          <span
            style={{
              display: 'block',
              paddingTop: '1rem',
              textAlign: 'center',
              fontSize: '1.3rem',
              color: '#6c7786',
            }}
          >
            MarkAll
          </span>
        </div>
      </div>
      <div style={{ width: '20%', padding: '0.5rem' }}>
        <div
          style={{
            height: '100%',
            padding: '1rem',
            border: '1px solid #c5c9ce',
            borderRadius: 5,
          }}
        >
          <div style={{ display: 'flex', justifyContent: 'center' }}>
            <Icons.Notification />
          </div>
          <span
            style={{
              display: 'block',
              paddingTop: '1rem',
              textAlign: 'center',
              fontSize: '1.3rem',
              color: '#6c7786',
            }}
          >
            Notification
          </span>
        </div>
      </div>
      <div style={{ width: '20%', padding: '0.5rem' }}>
        <div
          style={{
            height: '100%',
            padding: '1rem',
            border: '1px solid #c5c9ce',
            borderRadius: 5,
          }}
        >
          <div style={{ display: 'flex', justifyContent: 'center' }}>
            <Icons.NotificationsArrow />
          </div>
          <span
            style={{
              display: 'block',
              paddingTop: '1rem',
              textAlign: 'center',
              fontSize: '1.3rem',
              color: '#6c7786',
            }}
          >
            NotificationsArrow
          </span>
        </div>
      </div>
      <div style={{ width: '20%', padding: '0.5rem' }}>
        <div
          style={{
            height: '100%',
            padding: '1rem',
            border: '1px solid #c5c9ce',
            borderRadius: 5,
          }}
        >
          <div style={{ display: 'flex', justifyContent: 'center' }}>
            <Icons.NotificationsClose />
          </div>
          <span
            style={{
              display: 'block',
              paddingTop: '1rem',
              textAlign: 'center',
              fontSize: '1.3rem',
              color: '#6c7786',
            }}
          >
            NotificationsClose
          </span>
        </div>
      </div>
      <div style={{ width: '20%', padding: '0.5rem' }}>
        <div
          style={{
            height: '100%',
            padding: '1rem',
            border: '1px solid #c5c9ce',
            borderRadius: 5,
          }}
        >
          <div style={{ display: 'flex', justifyContent: 'center' }}>
            <Icons.NotificationsError />
          </div>
          <span
            style={{
              display: 'block',
              paddingTop: '1rem',
              textAlign: 'center',
              fontSize: '1.3rem',
              color: '#6c7786',
            }}
          >
            NotificationsError
          </span>
        </div>
      </div>
      <div style={{ width: '20%', padding: '0.5rem' }}>
        <div
          style={{
            height: '100%',
            padding: '1rem',
            border: '1px solid #c5c9ce',
            borderRadius: 5,
          }}
        >
          <div style={{ display: 'flex', justifyContent: 'center' }}>
            <Icons.NotificationsInfo />
          </div>
          <span
            style={{
              display: 'block',
              paddingTop: '1rem',
              textAlign: 'center',
              fontSize: '1.3rem',
              color: '#6c7786',
            }}
          >
            NotificationsInfo
          </span>
        </div>
      </div>
      <div style={{ width: '20%', padding: '0.5rem' }}>
        <div
          style={{
            height: '100%',
            padding: '1rem',
            border: '1px solid #c5c9ce',
            borderRadius: 5,
          }}
        >
          <div style={{ display: 'flex', justifyContent: 'center' }}>
            <Icons.NotificationsTip />
          </div>
          <span
            style={{
              display: 'block',
              paddingTop: '1rem',
              textAlign: 'center',
              fontSize: '1.3rem',
              color: '#6c7786',
            }}
          >
            NotificationsTip
          </span>
        </div>
      </div>
      <div style={{ width: '20%', padding: '0.5rem' }}>
        <div
          style={{
            height: '100%',
            padding: '1rem',
            border: '1px solid #c5c9ce',
            borderRadius: 5,
          }}
        >
          <div style={{ display: 'flex', justifyContent: 'center' }}>
            <Icons.NotificationsWarning />
          </div>
          <span
            style={{
              display: 'block',
              paddingTop: '1rem',
              textAlign: 'center',
              fontSize: '1.3rem',
              color: '#6c7786',
            }}
          >
            NotificationsWarning
          </span>
        </div>
      </div>
      <div style={{ width: '20%', padding: '0.5rem' }}>
        <div
          style={{
            height: '100%',
            padding: '1rem',
            border: '1px solid #c5c9ce',
            borderRadius: 5,
          }}
        >
          <div style={{ display: 'flex', justifyContent: 'center' }}>
            <Icons.OperationalServices />
          </div>
          <span
            style={{
              display: 'block',
              paddingTop: '1rem',
              textAlign: 'center',
              fontSize: '1.3rem',
              color: '#6c7786',
            }}
          >
            OperationalServices
          </span>
        </div>
      </div>
      <div style={{ width: '20%', padding: '0.5rem' }}>
        <div
          style={{
            height: '100%',
            padding: '1rem',
            border: '1px solid #c5c9ce',
            borderRadius: 5,
          }}
        >
          <div style={{ display: 'flex', justifyContent: 'center' }}>
            <Icons.Padlock />
          </div>
          <span
            style={{
              display: 'block',
              paddingTop: '1rem',
              textAlign: 'center',
              fontSize: '1.3rem',
              color: '#6c7786',
            }}
          >
            Padlock
          </span>
        </div>
      </div>
      <div style={{ width: '20%', padding: '0.5rem' }}>
        <div
          style={{
            height: '100%',
            padding: '1rem',
            border: '1px solid #c5c9ce',
            borderRadius: 5,
          }}
        >
          <div style={{ display: 'flex', justifyContent: 'center' }}>
            <Icons.PadlockOpen />
          </div>
          <span
            style={{
              display: 'block',
              paddingTop: '1rem',
              textAlign: 'center',
              fontSize: '1.3rem',
              color: '#6c7786',
            }}
          >
            PadlockOpen
          </span>
        </div>
      </div>
      <div style={{ width: '20%', padding: '0.5rem' }}>
        <div
          style={{
            height: '100%',
            padding: '1rem',
            border: '1px solid #c5c9ce',
            borderRadius: 5,
          }}
        >
          <div style={{ display: 'flex', justifyContent: 'center' }}>
            <Icons.PasswordShow />
          </div>
          <span
            style={{
              display: 'block',
              paddingTop: '1rem',
              textAlign: 'center',
              fontSize: '1.3rem',
              color: '#6c7786',
            }}
          >
            PasswordShow
          </span>
        </div>
      </div>
      <div style={{ width: '20%', padding: '0.5rem' }}>
        <div
          style={{
            height: '100%',
            padding: '1rem',
            border: '1px solid #c5c9ce',
            borderRadius: 5,
          }}
        >
          <div style={{ display: 'flex', justifyContent: 'center' }}>
            <Icons.PasswordHide />
          </div>
          <span
            style={{
              display: 'block',
              paddingTop: '1rem',
              textAlign: 'center',
              fontSize: '1.3rem',
              color: '#6c7786',
            }}
          >
            PasswordHide
          </span>
        </div>
      </div>
      <div style={{ width: '20%', padding: '0.5rem' }}>
        <div
          style={{
            height: '100%',
            padding: '1rem',
            border: '1px solid #c5c9ce',
            borderRadius: 5,
          }}
        >
          <div style={{ display: 'flex', justifyContent: 'center' }}>
            <Icons.PaymentOptions />
          </div>
          <span
            style={{
              display: 'block',
              paddingTop: '1rem',
              textAlign: 'center',
              fontSize: '1.3rem',
              color: '#6c7786',
            }}
          >
            PaymentOptions
          </span>
        </div>
      </div>
      <div style={{ width: '20%', padding: '0.5rem' }}>
        <div
          style={{
            height: '100%',
            padding: '1rem',
            border: '1px solid #c5c9ce',
            borderRadius: 5,
          }}
        >
          <div style={{ display: 'flex', justifyContent: 'center' }}>
            <Icons.Pension />
          </div>
          <span
            style={{
              display: 'block',
              paddingTop: '1rem',
              textAlign: 'center',
              fontSize: '1.3rem',
              color: '#6c7786',
            }}
          >
            Pension
          </span>
        </div>
      </div>
      <div style={{ width: '20%', padding: '0.5rem' }}>
        <div
          style={{
            height: '100%',
            padding: '1rem',
            border: '1px solid #c5c9ce',
            borderRadius: 5,
          }}
        >
          <div style={{ display: 'flex', justifyContent: 'center' }}>
            <Icons.ProductAdd />
          </div>
          <span
            style={{
              display: 'block',
              paddingTop: '1rem',
              textAlign: 'center',
              fontSize: '1.3rem',
              color: '#6c7786',
            }}
          >
            ProductAdd
          </span>
        </div>
      </div>
      <div style={{ width: '20%', padding: '0.5rem' }}>
        <div
          style={{
            height: '100%',
            padding: '1rem',
            border: '1px solid #c5c9ce',
            borderRadius: 5,
          }}
        >
          <div style={{ display: 'flex', justifyContent: 'center' }}>
            <Icons.ProductRemove />
          </div>
          <span
            style={{
              display: 'block',
              paddingTop: '1rem',
              textAlign: 'center',
              fontSize: '1.3rem',
              color: '#6c7786',
            }}
          >
            ProductRemove
          </span>
        </div>
      </div>
      <div style={{ width: '20%', padding: '0.5rem' }}>
        <div
          style={{
            height: '100%',
            padding: '1rem',
            border: '1px solid #c5c9ce',
            borderRadius: 5,
          }}
        >
          <div style={{ display: 'flex', justifyContent: 'center' }}>
            <Icons.Print />
          </div>
          <span
            style={{
              display: 'block',
              paddingTop: '1rem',
              textAlign: 'center',
              fontSize: '1.3rem',
              color: '#6c7786',
            }}
          >
            Print
          </span>
        </div>
      </div>
      <div style={{ width: '20%', padding: '0.5rem' }}>
        <div
          style={{
            height: '100%',
            padding: '1rem',
            border: '1px solid #c5c9ce',
            borderRadius: 5,
          }}
        >
          <div style={{ display: 'flex', justifyContent: 'center' }}>
            <Icons.Report />
          </div>
          <span
            style={{
              display: 'block',
              paddingTop: '1rem',
              textAlign: 'center',
              fontSize: '1.3rem',
              color: '#6c7786',
            }}
          >
            Report
          </span>
        </div>
      </div>
      <div style={{ width: '20%', padding: '0.5rem' }}>
        <div
          style={{
            height: '100%',
            padding: '1rem',
            border: '1px solid #c5c9ce',
            borderRadius: 5,
          }}
        >
          <div style={{ display: 'flex', justifyContent: 'center' }}>
            <Icons.ResendMail />
          </div>
          <span
            style={{
              display: 'block',
              paddingTop: '1rem',
              textAlign: 'center',
              fontSize: '1.3rem',
              color: '#6c7786',
            }}
          >
            ResendMail
          </span>
        </div>
      </div>
      <div style={{ width: '20%', padding: '0.5rem' }}>
        <div
          style={{
            height: '100%',
            padding: '1rem',
            border: '1px solid #c5c9ce',
            borderRadius: 5,
          }}
        >
          <div style={{ display: 'flex', justifyContent: 'center' }}>
            <Icons.Search />
          </div>
          <span
            style={{
              display: 'block',
              paddingTop: '1rem',
              textAlign: 'center',
              fontSize: '1.3rem',
              color: '#6c7786',
            }}
          >
            Search
          </span>
        </div>
      </div>
      <div style={{ width: '20%', padding: '0.5rem' }}>
        <div
          style={{
            height: '100%',
            padding: '1rem',
            border: '1px solid #c5c9ce',
            borderRadius: 5,
          }}
        >
          <div style={{ display: 'flex', justifyContent: 'center' }}>
            <Icons.SearchList />
          </div>
          <span
            style={{
              display: 'block',
              paddingTop: '1rem',
              textAlign: 'center',
              fontSize: '1.3rem',
              color: '#6c7786',
            }}
          >
            SearchList
          </span>
        </div>
      </div>
      <div style={{ width: '20%', padding: '0.5rem' }}>
        <div
          style={{
            height: '100%',
            padding: '1rem',
            border: '1px solid #c5c9ce',
            borderRadius: 5,
          }}
        >
          <div style={{ display: 'flex', justifyContent: 'center' }}>
            <Icons.SearchMobile />
          </div>
          <span
            style={{
              display: 'block',
              paddingTop: '1rem',
              textAlign: 'center',
              fontSize: '1.3rem',
              color: '#6c7786',
            }}
          >
            SearchMobile
          </span>
        </div>
      </div>
      <div style={{ width: '20%', padding: '0.5rem' }}>
        <div
          style={{
            height: '100%',
            padding: '1rem',
            border: '1px solid #c5c9ce',
            borderRadius: 5,
          }}
        >
          <div style={{ display: 'flex', justifyContent: 'center' }}>
            <Icons.Send />
          </div>
          <span
            style={{
              display: 'block',
              paddingTop: '1rem',
              textAlign: 'center',
              fontSize: '1.3rem',
              color: '#6c7786',
            }}
          >
            Send
          </span>
        </div>
      </div>
      <div style={{ width: '20%', padding: '0.5rem' }}>
        <div
          style={{
            height: '100%',
            padding: '1rem',
            border: '1px solid #c5c9ce',
            borderRadius: 5,
          }}
        >
          <div style={{ display: 'flex', justifyContent: 'center' }}>
            <Icons.SendMail />
          </div>
          <span
            style={{
              display: 'block',
              paddingTop: '1rem',
              textAlign: 'center',
              fontSize: '1.3rem',
              color: '#6c7786',
            }}
          >
            SendMail
          </span>
        </div>
      </div>
      <div style={{ width: '20%', padding: '0.5rem' }}>
        <div
          style={{
            height: '100%',
            padding: '1rem',
            border: '1px solid #c5c9ce',
            borderRadius: 5,
          }}
        >
          <div style={{ display: 'flex', justifyContent: 'center' }}>
            <Icons.ShoppingCart />
          </div>
          <span
            style={{
              display: 'block',
              paddingTop: '1rem',
              textAlign: 'center',
              fontSize: '1.3rem',
              color: '#6c7786',
            }}
          >
            ShoppingCart
          </span>
        </div>
      </div>
      <div style={{ width: '20%', padding: '0.5rem' }}>
        <div
          style={{
            height: '100%',
            padding: '1rem',
            border: '1px solid #c5c9ce',
            borderRadius: 5,
          }}
        >
          <div style={{ display: 'flex', justifyContent: 'center' }}>
            <Icons.ShoppingCartCheck />
          </div>
          <span
            style={{
              display: 'block',
              paddingTop: '1rem',
              textAlign: 'center',
              fontSize: '1.3rem',
              color: '#6c7786',
            }}
          >
            ShoppingCartCheck
          </span>
        </div>
      </div>
      <div style={{ width: '20%', padding: '0.5rem' }}>
        <div
          style={{
            height: '100%',
            padding: '1rem',
            border: '1px solid #c5c9ce',
            borderRadius: 5,
          }}
        >
          <div style={{ display: 'flex', justifyContent: 'center' }}>
            <Icons.ShoppingCartMobile />
          </div>
          <span
            style={{
              display: 'block',
              paddingTop: '1rem',
              textAlign: 'center',
              fontSize: '1.3rem',
              color: '#6c7786',
            }}
          >
            ShoppingCartMobile
          </span>
        </div>
      </div>
      <div style={{ width: '20%', padding: '0.5rem' }}>
        <div
          style={{
            height: '100%',
            padding: '1rem',
            border: '1px solid #c5c9ce',
            borderRadius: 5,
          }}
        >
          <div style={{ display: 'flex', justifyContent: 'center' }}>
            <Icons.Statistic />
          </div>
          <span
            style={{
              display: 'block',
              paddingTop: '1rem',
              textAlign: 'center',
              fontSize: '1.3rem',
              color: '#6c7786',
            }}
          >
            Statistic
          </span>
        </div>
      </div>
      <div style={{ width: '20%', padding: '0.5rem' }}>
        <div
          style={{
            height: '100%',
            padding: '1rem',
            border: '1px solid #c5c9ce',
            borderRadius: 5,
          }}
        >
          <div style={{ display: 'flex', justifyContent: 'center' }}>
            <Icons.SubscriptionCashflow />
          </div>
          <span
            style={{
              display: 'block',
              paddingTop: '1rem',
              textAlign: 'center',
              fontSize: '1.3rem',
              color: '#6c7786',
            }}
          >
            SubscriptionCashflow
          </span>
        </div>
      </div>
      <div style={{ width: '20%', padding: '0.5rem' }}>
        <div
          style={{
            height: '100%',
            padding: '1rem',
            border: '1px solid #c5c9ce',
            borderRadius: 5,
          }}
        >
          <div style={{ display: 'flex', justifyContent: 'center' }}>
            <Icons.Subtract />
          </div>
          <span
            style={{
              display: 'block',
              paddingTop: '1rem',
              textAlign: 'center',
              fontSize: '1.3rem',
              color: '#6c7786',
            }}
          >
            Subtract
          </span>
        </div>
      </div>
      <div style={{ width: '20%', padding: '0.5rem' }}>
        <div
          style={{
            height: '100%',
            padding: '1rem',
            border: '1px solid #c5c9ce',
            borderRadius: 5,
          }}
        >
          <div style={{ display: 'flex', justifyContent: 'center' }}>
            <Icons.Ticket />
          </div>
          <span
            style={{
              display: 'block',
              paddingTop: '1rem',
              textAlign: 'center',
              fontSize: '1.3rem',
              color: '#6c7786',
            }}
          >
            Ticket
          </span>
        </div>
      </div>
      <div style={{ width: '20%', padding: '0.5rem' }}>
        <div
          style={{
            height: '100%',
            padding: '1rem',
            border: '1px solid #c5c9ce',
            borderRadius: 5,
          }}
        >
          <div style={{ display: 'flex', justifyContent: 'center' }}>
            <Icons.TimeWorked />
          </div>
          <span
            style={{
              display: 'block',
              paddingTop: '1rem',
              textAlign: 'center',
              fontSize: '1.3rem',
              color: '#6c7786',
            }}
          >
            TimeWorked
          </span>
        </div>
      </div>
      <div style={{ width: '20%', padding: '0.5rem' }}>
        <div
          style={{
            height: '100%',
            padding: '1rem',
            border: '1px solid #c5c9ce',
            borderRadius: 5,
          }}
        >
          <div style={{ display: 'flex', justifyContent: 'center' }}>
            <Icons.ToastActionArrow />
          </div>
          <span
            style={{
              display: 'block',
              paddingTop: '1rem',
              textAlign: 'center',
              fontSize: '1.3rem',
              color: '#6c7786',
            }}
          >
            ToastActionArrow
          </span>
        </div>
      </div>
      <div style={{ width: '20%', padding: '0.5rem' }}>
        <div
          style={{
            height: '100%',
            padding: '1rem',
            border: '1px solid #c5c9ce',
            borderRadius: 5,
          }}
        >
          <div style={{ display: 'flex', justifyContent: 'center' }}>
            <Icons.User />
          </div>
          <span
            style={{
              display: 'block',
              paddingTop: '1rem',
              textAlign: 'center',
              fontSize: '1.3rem',
              color: '#6c7786',
            }}
          >
            User
          </span>
        </div>
      </div>
      <div style={{ width: '20%', padding: '0.5rem' }}>
        <div
          style={{
            height: '100%',
            padding: '1rem',
            border: '1px solid #c5c9ce',
            borderRadius: 5,
          }}
        >
          <div style={{ display: 'flex', justifyContent: 'center' }}>
            <Icons.UsersGroup />
          </div>
          <span
            style={{
              display: 'block',
              paddingTop: '1rem',
              textAlign: 'center',
              fontSize: '1.3rem',
              color: '#6c7786',
            }}
          >
            UsersGroup
          </span>
        </div>
      </div>
      <div style={{ width: '20%', padding: '0.5rem' }}>
        <div
          style={{
            height: '100%',
            padding: '1rem',
            border: '1px solid #c5c9ce',
            borderRadius: 5,
          }}
        >
          <div style={{ display: 'flex', justifyContent: 'center' }}>
            <Icons.UserMobile />
          </div>
          <span
            style={{
              display: 'block',
              paddingTop: '1rem',
              textAlign: 'center',
              fontSize: '1.3rem',
              color: '#6c7786',
            }}
          >
            UserMobile
          </span>
        </div>
      </div>
      <div style={{ width: '20%', padding: '0.5rem' }}>
        <div
          style={{
            height: '100%',
            padding: '1rem',
            border: '1px solid #c5c9ce',
            borderRadius: 5,
          }}
        >
          <div style={{ display: 'flex', justifyContent: 'center' }}>
            <Icons.Voucher />
          </div>
          <span
            style={{
              display: 'block',
              paddingTop: '1rem',
              textAlign: 'center',
              fontSize: '1.3rem',
              color: '#6c7786',
            }}
          >
            Voucher
          </span>
        </div>
      </div>
      <div style={{ width: '20%', padding: '0.5rem' }}>
        <div
          style={{
            height: '100%',
            padding: '1rem',
            border: '1px solid #c5c9ce',
            borderRadius: 5,
          }}
        >
          <div style={{ display: 'flex', justifyContent: 'center' }}>
            <Icons.Wallet />
          </div>
          <span
            style={{
              display: 'block',
              paddingTop: '1rem',
              textAlign: 'center',
              fontSize: '1.3rem',
              color: '#6c7786',
            }}
          >
            Wallet
          </span>
        </div>
      </div>
      <div style={{ width: '20%', padding: '0.5rem' }}>
        <div
          style={{
            height: '100%',
            padding: '1rem',
            border: '1px solid #c5c9ce',
            borderRadius: 5,
          }}
        >
          <div style={{ display: 'flex', justifyContent: 'center' }}>
            <Icons.WeChat />
          </div>
          <span
            style={{
              display: 'block',
              paddingTop: '1rem',
              textAlign: 'center',
              fontSize: '1.3rem',
              color: '#6c7786',
            }}
          >
            WeChat
          </span>
        </div>
      </div>
      <div style={{ width: '20%', padding: '0.5rem' }}>
        <div
          style={{
            height: '100%',
            padding: '1rem',
            border: '1px solid #c5c9ce',
            borderRadius: 5,
          }}
        >
          <div style={{ display: 'flex', justifyContent: 'center' }}>
            <Icons.Dislike />
          </div>
          <span
            style={{
              display: 'block',
              paddingTop: '1rem',
              textAlign: 'center',
              fontSize: '1.3rem',
              color: '#6c7786',
            }}
          >
            Dislike
          </span>
        </div>
      </div>
      <div style={{ width: '20%', padding: '0.5rem' }}>
        <div
          style={{
            height: '100%',
            padding: '1rem',
            border: '1px solid #c5c9ce',
            borderRadius: 5,
          }}
        >
          <div style={{ display: 'flex', justifyContent: 'center' }}>
            <Icons.HelpRed />
          </div>
          <span
            style={{
              display: 'block',
              paddingTop: '1rem',
              textAlign: 'center',
              fontSize: '1.3rem',
              color: '#6c7786',
            }}
          >
            HelpRed
          </span>
        </div>
      </div>
      <div style={{ width: '20%', padding: '0.5rem' }}>
        <div
          style={{
            height: '100%',
            padding: '1rem',
            border: '1px solid #c5c9ce',
            borderRadius: 5,
          }}
        >
          <div style={{ display: 'flex', justifyContent: 'center' }}>
            <Icons.WarningRed />
          </div>
          <span
            style={{
              display: 'block',
              paddingTop: '1rem',
              textAlign: 'center',
              fontSize: '1.3rem',
              color: '#6c7786',
            }}
          >
            WarningRed
          </span>
        </div>
      </div>
      <div style={{ width: '20%', padding: '0.5rem' }}>
        <div
          style={{
            height: '100%',
            padding: '1rem',
            border: '1px solid #c5c9ce',
            borderRadius: 5,
          }}
        >
          <div style={{ display: 'flex', justifyContent: 'center' }}>
            <Icons.Like />
          </div>
          <span
            style={{
              display: 'block',
              paddingTop: '1rem',
              textAlign: 'center',
              fontSize: '1.3rem',
              color: '#6c7786',
            }}
          >
            Like
          </span>
        </div>
      </div>
      <div style={{ width: '20%', padding: '0.5rem' }}>
        <div
          style={{
            height: '100%',
            padding: '1rem',
            border: '1px solid #c5c9ce',
            borderRadius: 5,
          }}
        >
          <div style={{ display: 'flex', justifyContent: 'center' }}>
            <Icons.LocationPin />
          </div>
          <span
            style={{
              display: 'block',
              paddingTop: '1rem',
              textAlign: 'center',
              fontSize: '1.3rem',
              color: '#6c7786',
            }}
          >
            LocationPin
          </span>
        </div>
      </div>
      <div style={{ width: '20%', padding: '0.5rem' }}>
        <div
          style={{
            height: '100%',
            padding: '1rem',
            border: '1px solid #c5c9ce',
            borderRadius: 5,
          }}
        >
          <div style={{ display: 'flex', justifyContent: 'center' }}>
            <Icons.Success />
          </div>
          <span
            style={{
              display: 'block',
              paddingTop: '1rem',
              textAlign: 'center',
              fontSize: '1.3rem',
              color: '#6c7786',
            }}
          >
            Success
          </span>
        </div>
      </div>
      <div style={{ width: '20%', padding: '0.5rem' }}>
        <div
          style={{
            height: '100%',
            padding: '1rem',
            border: '1px solid #c5c9ce',
            borderRadius: 5,
          }}
        >
          <div style={{ display: 'flex', justifyContent: 'center' }}>
            <Icons.ToastError />
          </div>
          <span
            style={{
              display: 'block',
              paddingTop: '1rem',
              textAlign: 'center',
              fontSize: '1.3rem',
              color: '#6c7786',
            }}
          >
            ToastError
          </span>
        </div>
      </div>
      <div style={{ width: '20%', padding: '0.5rem' }}>
        <div
          style={{
            height: '100%',
            padding: '1rem',
            border: '1px solid #c5c9ce',
            borderRadius: 5,
          }}
        >
          <div style={{ display: 'flex', justifyContent: 'center' }}>
            <Icons.ToastInfo />
          </div>
          <span
            style={{
              display: 'block',
              paddingTop: '1rem',
              textAlign: 'center',
              fontSize: '1.3rem',
              color: '#6c7786',
            }}
          >
            ToastInfo
          </span>
        </div>
      </div>
      <div style={{ width: '20%', padding: '0.5rem' }}>
        <div
          style={{
            height: '100%',
            padding: '1rem',
            border: '1px solid #c5c9ce',
            borderRadius: 5,
          }}
        >
          <div style={{ display: 'flex', justifyContent: 'center' }}>
            <Icons.ToastShoppingCart />
          </div>
          <span
            style={{
              display: 'block',
              paddingTop: '1rem',
              textAlign: 'center',
              fontSize: '1.3rem',
              color: '#6c7786',
            }}
          >
            ToastShoppingCart
          </span>
        </div>
      </div>
      <div style={{ width: '20%', padding: '0.5rem' }}>
        <div
          style={{
            height: '100%',
            padding: '1rem',
            border: '1px solid #c5c9ce',
            borderRadius: 5,
          }}
        >
          <div style={{ display: 'flex', justifyContent: 'center' }}>
            <Icons.ToastSuccess />
          </div>
          <span
            style={{
              display: 'block',
              paddingTop: '1rem',
              textAlign: 'center',
              fontSize: '1.3rem',
              color: '#6c7786',
            }}
          >
            ToastSuccess
          </span>
        </div>
      </div>
      <div style={{ width: '20%', padding: '0.5rem' }}>
        <div
          style={{
            height: '100%',
            padding: '1rem',
            border: '1px solid #c5c9ce',
            borderRadius: 5,
          }}
        >
          <div style={{ display: 'flex', justifyContent: 'center' }}>
            <Icons.ToastSmart />
          </div>
          <span
            style={{
              display: 'block',
              paddingTop: '1rem',
              textAlign: 'center',
              fontSize: '1.3rem',
              color: '#6c7786',
            }}
          >
            ToastSmart
          </span>
        </div>
      </div>
      <div style={{ width: '20%', padding: '0.5rem' }}>
        <div
          style={{
            height: '100%',
            padding: '1rem',
            border: '1px solid #c5c9ce',
            borderRadius: 5,
          }}
        >
          <div style={{ display: 'flex', justifyContent: 'center' }}>
            <Icons.VideoPlay />
          </div>
          <span
            style={{
              display: 'block',
              paddingTop: '1rem',
              textAlign: 'center',
              fontSize: '1.3rem',
              color: '#6c7786',
            }}
          >
            VideoPlay
          </span>
        </div>
      </div>
      <div style={{ width: '20%', padding: '0.5rem' }}>
        <div
          style={{
            height: '100%',
            padding: '1rem',
            border: '1px solid #c5c9ce',
            borderRadius: 5,
          }}
        >
          <div style={{ display: 'flex', justifyContent: 'center' }}>
            <Icons.Fb />
          </div>
          <span
            style={{
              display: 'block',
              paddingTop: '1rem',
              textAlign: 'center',
              fontSize: '1.3rem',
              color: '#6c7786',
            }}
          >
            Fb
          </span>
        </div>
      </div>
      <div style={{ width: '20%', padding: '0.5rem' }}>
        <div
          style={{
            height: '100%',
            padding: '1rem',
            border: '1px solid #c5c9ce',
            borderRadius: 5,
          }}
        >
          <div style={{ display: 'flex', justifyContent: 'center' }}>
            <Icons.In />
          </div>
          <span
            style={{
              display: 'block',
              paddingTop: '1rem',
              textAlign: 'center',
              fontSize: '1.3rem',
              color: '#6c7786',
            }}
          >
            In
          </span>
        </div>
      </div>
      <div style={{ width: '20%', padding: '0.5rem' }}>
        <div
          style={{
            height: '100%',
            padding: '1rem',
            border: '1px solid #c5c9ce',
            borderRadius: 5,
          }}
        >
          <div style={{ display: 'flex', justifyContent: 'center' }}>
            <Icons.Yt />
          </div>
          <span
            style={{
              display: 'block',
              paddingTop: '1rem',
              textAlign: 'center',
              fontSize: '1.3rem',
              color: '#6c7786',
            }}
          >
            Yt
          </span>
        </div>
      </div>
    </div>
  );
}
